import CustomInputField from "@components/FormFields/CustomInputField";
import { useDebounce } from "@hooks/use-debounce";
import React, { ChangeEvent, useEffect, useState } from "react";
import { MdSearch } from "react-icons/md";

export interface TemplateSearchBarProps {
  onChange: (val?: string) => void;
  value: string | undefined;
}

export default function TemplateSearchBar({ value: searchString, onChange: setSearchString }: TemplateSearchBarProps) {
  const [search, setSearch] = useState<string>(searchString ?? "");
  const debouncedValue = useDebounce<string>(search, 500);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  useEffect(() => {
    if (debouncedValue.length === 0) {
      setSearchString?.(undefined);
    } else if (debouncedValue.length >= 3) {
      setSearchString?.(debouncedValue);
    }
  }, [debouncedValue, setSearchString]);

  return (
    <div className="w-full max-w-lg">
      <CustomInputField
        leadingIcon={<MdSearch />}
        value={search}
        onChange={handleChange}
        placeholder="Search for a template"
        className="w-full"
      />
    </div>
  );
}
